import React, { useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Card, CardContent } from '@material-ui/core';
import StarIcon from '@material-ui/icons/Star';
import { Pagination } from '@rcg/ui-react';
import { makeStyles } from '@material-ui/core/styles';
import useStyles from './useStyles';
import { filteredResultsVar } from '../../operations/localState/reactiveVariables';
import FlightInformation from './components/FlightInformation';
import FlightExpanded from './components/FlightExpanded';
import getBrand from '../../utils/getBrand';
import useDictionary from '../../hooks/useDictionary';
import Dictionary from '../../utils/dictionary';

const useBestPriceStyles = makeStyles(() => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    backgroundColor: '#0E1F40',
    padding: '8px 16px',
    borderRadius: '4px 4px 0 0',
    marginBottom: '-4px',
  },
  bannerIcon: {
    fontSize: '14px',
    color: '#fff',
  },
  bannerText: {
    fontSize: '12px',
    fontWeight: 700,
    color: '#fff',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
}));

const BestPriceBanner = () => {
  const classes = useBestPriceStyles();
  const getDictionary = useDictionary(Dictionary);
  return (
    <div className={classes.banner}>
      <StarIcon className={classes.bannerIcon} />
      <span className={classes.bannerText}>{getDictionary(Dictionary.airBestPriceLabel.key)}</span>
    </div>
  );
};

const isCelebrity = getBrand().name === 'celebrity';

const ResultsCard = ({ flightType }) => {
  const classes = useStyles();
  const [paginatedData, setPaginatedData] = useState([]);
  const filteredResults = useReactiveVar(filteredResultsVar);

  const onChangePage = (data) => {
    const paginatedItems = data.paginatedItems.length ? data.paginatedItems : null;
    setPaginatedData(paginatedItems);
    document.getElementsByClassName('main-container')[0].scrollTop = 0;
  };

  return (
    <>
      {paginatedData &&
        paginatedData.map((flight, index) => (
          <React.Fragment key={flight.routeId}>
            {isCelebrity && index === 0 && <BestPriceBanner />}
            <Card elevation={1} className={classes.resultCardWrapper}>
              <CardContent className={classes.resultCard}>
                <FlightInformation flight={flight} flightType={flightType} />
              </CardContent>
              <FlightExpanded flight={flight} flightType={flightType} />
            </Card>
          </React.Fragment>
        ))}
      <Pagination
        items={filteredResults}
        className={classes.overridePagination}
        onChangePage={onChangePage}
        itemsPerPage={10}
      />
    </>
  );
};

export default ResultsCard;
